import Swal, { SweetAlertResult } from 'sweetalert2';

export namespace AlertUtils {

  export function showConfirmForm(title: string, msg: string, confirmButtonText: string = 'Sim', cancelButtonText: string = 'Cancelar'): Promise<boolean> {
    const result = new Promise<boolean>(resolve => {
      Swal.fire({
        title: title,
        text: msg,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: confirmButtonText,
        cancelButtonText: cancelButtonText
      }).then((result) => {
        if (result.value) {
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });
    return result;
  }

  export function showSuccessAlert(titulo: string, msg: string = ''): Promise<SweetAlertResult> {
    return Swal.fire(
      titulo,
      msg,
      'success'
    );
  }
}
